const API = process.env.REACT_APP_API_URL || '';
const BASE = `${API}/api/readiness`;

async function parse(res) {
  try { return await res.json(); } catch { return { success: false, message: 'No answer from the server' }; }
}
export async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${BASE}${path}`, { method, credentials: 'include', headers: body ? { 'Content-Type': 'application/json' } : undefined, body: body ? JSON.stringify(body) : undefined });
  return parse(res);
}
/** Files go up as multipart; the browser sets the boundary. */
export async function apiUpload(path, formData) {
  const res = await fetch(`${BASE}${path}`, { method: 'POST', credentials: 'include', body: formData });
  return parse(res);
}
/** Downloads (files, .eml, Excel) are plain links so the browser saves them with the server's file name. */
export function downloadUrl(path) { return `${BASE}${path}`; }

export function fmtDay(d) {
  if (!d) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d));
  const dt = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(d);
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}
export function fmtWhen(d) { return d ? new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : ''; }
export function daysLeft(d) {
  if (!d) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d)); if (!m) return null;
  const due = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return Math.round((due - today) / 86400000);
}

export const STATUS_WORDS = {
  not_started: 'Not started', with_owner: 'With owner', submitted: 'Submitted', needs_more: 'Needs more', at_risk: 'At risk',
  ready: 'Ready', closed_by_policy: 'Closed by policy', not_applicable: 'Not applicable',
};
export const STATUS_TONE = {
  not_started: 'bg-slate-100 text-slate-700 ring-slate-200', with_owner: 'bg-amber-50 text-amber-800 ring-amber-200', submitted: 'bg-sky-50 text-sky-800 ring-sky-200',
  needs_more: 'bg-rose-50 text-rose-700 ring-rose-200', at_risk: 'bg-rose-50 text-rose-700 ring-rose-200', ready: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  closed_by_policy: 'bg-blue-50 text-blue-800 ring-blue-200', not_applicable: 'bg-slate-50 text-slate-500 ring-slate-200',
};
export const KIND_WORDS = { show: 'Show it', confirm: 'Confirm it', read: 'Read it' };
export const KIND_HINT = { show: 'a document is expected', confirm: 'a yes and one line on how', read: 'read and acknowledge' };
export const CLOSED = new Set(['ready', 'closed_by_policy', 'not_applicable']);

/** CMS's own names: section "H. Customer Service", subsection "III. Medication Therapy Management (MTM) Programs – Part D Sponsors", item "H.III.1". */
export const romanOf = (topicKey) => String(topicKey || '').split('.')[1] || '';
export function cmsSection(x) { const l = String(x?.section_letter || '').trim(); const t = String(x?.section_title || '').trim(); return l ? `${l}. ${t}`.trim() : t; }
export function cmsSubsection(x) { const r = romanOf(x?.topic_key); const t = String(x?.topic_cms_title || x?.topic_title || '').trim(); return r ? `${r}. ${t}`.trim() : t; }
export function cmsSubsectionOfTopic(t) { return t ? `${t.roman}. ${t.cms_title || t.title}` : ''; }

/** "Systems, Data, & Connectivity" reads better short in a badge line. */
export function shortSection(title) {
  return String(title || '').replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s+/g, ' ').trim();
}
export function itemFromUrl() { try { return new URLSearchParams(window.location.search).get('item') || null; } catch { return null; } }
export function setItemInUrl(id) {
  try {
    const u = new URL(window.location.href);
    if (id) u.searchParams.set('item', id); else u.searchParams.delete('item');
    window.history.replaceState({}, '', u.toString());
  } catch { /* no address bar */ }
}
